import * as apifetch from './fetch.js';

export async function getPartnerFees() {
    const urlEndpoint = '/v2/admin/reports/fees';

    return apifetch.authFetch(urlEndpoint, 'GET');
}
